import { redirect, type RouteObject } from 'react-router-dom';

export const managementRoute: RouteObject = {
  path: 'management',
  children: [
    {
      path: '',
      loader: () => redirect('sandbox'),
    },
    {
      path: 'sandbox',
      lazy: () => import('./sandbox'),
    },
    {
      path: 'import',
      children: [
        {
          path: '',
          lazy: () => import('./import/index'),
        },
        {
          path: 'items',
          lazy: () => import('./import/item'),
        },
        {
          path: 'snapshot',
          lazy: () => import('./import/snapshot'),
        },
        {
          path: 'gifts',
          lazy: () => import('./import/gift'),
        },
        {
          path: 'season-passes',
          lazy: () => import('./import/seasonPass'),
        },
      ],
    },
  ],
};
